import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, ButtonGroup } from 'reactstrap';
import Slider from 'rc-slider';

import {
  undo, redo, toggleLayers, toggleGrid, setZoom,
  alignHorizontalLeft, alignHorizontalCenter, alignHorizontalRight,
  alignVerticalTop, alignVerticalCenter, alignVerticalBottom,
  toggleGuide, flipHorizontal, flipVertical
} from "../actions";

class Toolbar extends Component {

  constructor(props) {
    super(props);
    this.handleUndo = this.handleUndo.bind(this);
    this.handleRedo = this.handleRedo.bind(this);
    this.handleToggleLayers = this.handleToggleLayers.bind(this);
    this.handleHorizontalAlignLeft = this.handleHorizontalAlignLeft.bind(this);
    this.handleHorizontalAlignCenter = this.handleHorizontalAlignCenter.bind(this);
    this.handleHorizontalAlignRight = this.handleHorizontalAlignRight.bind(this);
    this.handleVerticalAlignTop = this.handleVerticalAlignTop.bind(this);
    this.handleVerticalAlignCenter = this.handleVerticalAlignCenter.bind(this);
    this.handleVerticalAlignBottom = this.handleVerticalAlignBottom.bind(this);
    this.handleToggleGrid = this.handleToggleGrid.bind(this);
    this.handleZoomUp = this.handleZoomUp.bind(this);
    this.handleZoomDown = this.handleZoomDown.bind(this);
    this.handleZoomChange = this.handleZoomChange.bind(this);
    this.handleToggleGuide = this.handleToggleGuide.bind(this);
    this.handleFlipVertical = this.handleFlipVertical.bind(this);
    this.handleFlipHorizontal = this.handleFlipHorizontal.bind(this);
  }

  handleUndo() {
    this.props.undo();
  }

  handleRedo() {
    this.props.redo();
  }

  handleToggleLayers() {
    this.props.toggleLayers();
  }

  handleHorizontalAlignLeft() {
    this.props.alignHorizontalLeft(this.props.layers.selected);
  }

  handleHorizontalAlignCenter() {
    this.props.alignHorizontalCenter(this.props.layers.selected);
  }

  handleHorizontalAlignRight() {
    this.props.alignHorizontalRight(this.props.layers.selected);
  }

  handleVerticalAlignTop() {
    this.props.alignVerticalTop(this.props.layers.selected);
  }

  handleVerticalAlignCenter() {
    this.props.alignVerticalCenter(this.props.layers.selected);
  }

  handleVerticalAlignBottom() {
    this.props.alignVerticalBottom(this.props.layers.selected);
  }

  handleToggleGrid() {
    this.props.toggleGrid();
  }

  handleToggleGuide() {
    this.props.toggleGuide();
  }

  handleZoomChange(value) {
    this.props.setZoom(value);
  }

  handleZoomUp() {
    this.props.setZoom(this.props.canvas.zoom + 0.1);
  }

  handleZoomDown() {
    this.props.setZoom(this.props.canvas.zoom - 0.1);
  }

  handleFlipVertical() {
    this.props.flipVertical(this.props.layers.selected);
  }

  handleFlipHorizontal() {
    this.props.flipHorizontal(this.props.layers.selected);
  }

  render() {
    const surfaceId = this.props.objects.present.currentSurface.surface.id;

    const isUndoEnabled = (this.props.objects.past.length > 0);
    const isRedoEnabled = (this.props.objects.future.length > 0);
    const isGrouped = (this.props.layers.selected.length > 1);

    const isZoomUpEnabled = this.props.canvas.zoom < 2.0;
    const isZoomDownEnabled = this.props.canvas.zoom > 0.25;
    //const isZoomResetEnabled = this.props.canvas.zoom !== 1.0;
    const isFlippable = (this.props.layers.selected.length === 1) && this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]].type !== 'text';

    return (
      <div className="t-toolbar bg-dark">
        <ButtonGroup className="mr-1">
          <Button data-tip="レイヤー一覧" onClick={this.handleToggleLayers}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-layers.png"} alt="" width={22}/>
          </Button>
        </ButtonGroup>
        <ButtonGroup className="mr-1">
          <Button data-tip="元に戻す" onClick={this.handleUndo} disabled={!isUndoEnabled}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-undo.png"} alt="" width={18} />
          </Button>
          <Button  data-tip="やり直し" onClick={this.handleRedo} disabled={!isRedoEnabled}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-redo.png"} alt="" width={18}/>
          </Button>
        </ButtonGroup>
        <ButtonGroup className="mr-1">
          <Button data-tip="左寄せ" onClick={this.handleHorizontalAlignLeft} disabled={!isGrouped}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-left.png"} alt="" width={18} />
          </Button>
          <Button data-tip="中央寄せ" onClick={this.handleHorizontalAlignCenter} disabled={!isGrouped}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-h-center.png"} alt="" width={18} />
          </Button>
          <Button data-tip="右寄せ" onClick={this.handleHorizontalAlignRight} disabled={!isGrouped}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-right.png"} alt="" width={18} />
          </Button>
        </ButtonGroup>
        <ButtonGroup className="mr-1">
          <Button data-tip="上寄せ" onClick={this.handleVerticalAlignTop} disabled={!isGrouped}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-top.png"} alt="" width={16}/>
          </Button>
          <Button data-tip="上下中央寄せ" onClick={this.handleVerticalAlignCenter} disabled={!isGrouped}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-v-center.png"} alt="" width={16} />
          </Button>
          <Button data-tip="下寄せ" onClick={this.handleVerticalAlignBottom} disabled={!isGrouped}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-bottom.png"} alt="" width={16}/>
          </Button>
          <Button data-tip="左右反転" onClick={this.handleFlipHorizontal} disabled={!isFlippable}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-flip-horizontal.png"} alt="" width={18}/>
          </Button>
          <Button data-tip="上下反転" onClick={this.handleFlipVertical} disabled={!isFlippable}>
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-flip-vertical.png"} alt="" width={22}/>
          </Button>
        </ButtonGroup>
        {/*<ButtonGroup className="mr-1">*/}
          {/*<Button onClick={this.handleToggleGrid} active={this.props.canvas.grid}>GRIDs</Button>*/}
        {/*</ButtonGroup>*/}

        <div className="t-toolbar-right">
          <ButtonGroup className="mr-1">
            <Button data-tip="ガイド枠表示" onClick={this.handleToggleGuide} active={this.props.canvas.guide}>
              <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-guide.png"} alt="" width={20}/>
            </Button>
            <Button data-tip="グリッド線表示" onClick={this.handleToggleGrid} active={this.props.canvas.grid}>
              <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-grid.png"} alt="" width={22}/>
            </Button>
          </ButtonGroup>
          <ButtonGroup>
            <Button  onClick={this.handleZoomDown} disabled={!isZoomDownEnabled}><img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-zoom-out.png"} alt="" /></Button>
          </ButtonGroup>
          <div className="t-toolbar-slider">
            <Slider min={0.25} max={2.0} step={0.05} defaultValue={1.0} value={this.props.canvas.zoom} onChange={this.handleZoomChange} />
          </div>
          <ButtonGroup>
            <Button  onClick={this.handleZoomUp} disabled={!isZoomUpEnabled}><img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-zoom-in.png"} alt=""/></Button>
          </ButtonGroup>
        </div>
      </div>
    );
  }
}

export default connect(f => f, {
  undo, redo, toggleLayers, toggleGrid, setZoom,
  alignHorizontalLeft, alignHorizontalCenter, alignHorizontalRight,
  alignVerticalTop, alignVerticalCenter, alignVerticalBottom,
  toggleGuide, flipHorizontal, flipVertical
})(Toolbar);



// WEBPACK FOOTER //
// ./src/containers/Toolbar.js